import React from 'react';
import PageLayout from '../components/common/PageLayout';
import PaymentList from '../components/PaymentList';

const PaymentListPage = () => (
  <PageLayout
    title="Payment List"
    showFinanceSectionTabs
    showBreadcrumbs={false}
    navLinks={[
      { url: '/finance/reports/', label: 'Reports' },
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <PaymentList />
  </PageLayout>
);

export default PaymentListPage;
